export const SET_GLOBAL = "BROADCAST/SET_GLOBAL"
export const SET_PRIVATE = "BROADCAST/SET_PRIVATE"